import { render } from "./Community.vue?vue&type=template&id=6fdaea76&scoped=true&ts=true"
import script from "./Community.vue?vue&type=script&lang=ts"
export * from "./Community.vue?vue&type=script&lang=ts"

import "./Community.vue?vue&type=style&index=0&id=6fdaea76&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdaea76"]])

export default __exports__